export const passCheckTableColumns = [
  {
    key: "status",
    display_name: "Type",
    cellStyles: {
      "font-size": "13px",
    },
    headerStyles: {
      background: "#EBEAEA",
      width: "5%",      
      color: "#ffffff",
    },
    _config: {
      type: "svg",
      displayInColumn: false,
      value: "../../../../assets/images/virtusa-icons/pass-check.svg",
    },
  },
  {
    display_name: "",
    key: "type",
    headerStyles: {
      color: "#ffffff",
      background: "#EBEAEA",
      width: "10%",
    },
  },
  {
    display_name: "Criteria",
    key: "criteria",
    headerStyles: {
      width: "20%",
      color: "#ffffff",
      background: "#EBEAEA",
    },
  },
  {
    display_name: "Description",
    key: "positiveDescription",
    headerStyles: {
      width: "40%",
      color: "#ffffff",
      background: "#EBEAEA",
    },
  },
];

export const passCheckDummyData = [
  {
    type: "Specificity of Actors​​",
    status: "pass",
    description: "Admin is a clearly defined role.​",
  },
  {
    type: "Completeness of rules/conditional statements ​​",
    status: "pass",
    description: "Admin is a clearly defined role.​​",
  },
];
